import { styled } from "goober";

export const InfoIcon = styled("div")`
  display: flex;
  flex-shrink: 0;
  opacity: 0.2;
  &:hover {
    opacity: 1;
  }
`;
